import React, { useEffect, useState } from 'react';
import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";
import { changeSettings, getSettings } from "../../api/apiRequests";
import Loading from "../shared/wait/Loading";
import MySubmit from "../shared/form/MySubmit";
import SeasonCard from "./settings/SeasonCard";
import StoreInfo from "./settings/StoreInfo";
import defaultSettings from "../../utils/settings.default";
import { getCurrentSeasonName } from "../../utils/season";

const errorDetails = err =>
  ((err.response && err.response.data && err.response.data.errors) || [{ detail: "Error al guardar los ajustes" }])
    .map(({ detail }) => detail);

const Settings = () => {
  const [settings, setSettings] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    getSettings()
      .then(res => setSettings({ ...defaultSettings, ...res.data }))
      .catch(err => {
        // 404: nothing saved yet, start from the current web values
        setIsNew(!!err.response && err.response.status === 404);
        setSettings(cloneDeep(defaultSettings));
      });
  }, []);

  if (settings === null) return <Loading/>;

  const change = (path, value) => {
    setMessage(null);
    setSettings(prev => set(cloneDeep(prev), path, value));
  };
  const changeSeason = name => (path, value) => change(`seasons.${name}.${path}`, value);

  const save = event => {
    event.preventDefault();
    setIsSaving(true);
    changeSettings(settings)
      .then(res => {
        setSettings({ ...defaultSettings, ...res.data });
        setIsNew(false);
        setMessage({ type: "success", texts: ["Ajustes guardados. La web los mostrará al recargar."] });
      })
      .catch(err => setMessage({ type: "danger", texts: errorDetails(err) }))
      .then(() => setIsSaving(false));
  };

  const activeSeason = getCurrentSeasonName(settings.seasons);

  return (
    <form onSubmit={save} className="container py-4">
      <div className="row">
        <div className="col-12">
          <h1 className="ff-bobby text-primary">AJUSTES DE LA WEB</h1>
          <p className="mb-4">
            Cada horario se muestra en la web desde su fecha de inicio hasta que empieza el otro, todos los años
            (hora de Madrid). Temporada activa hoy: <strong>{activeSeason === "summer" ? "VERANO" : "INVIERNO"}</strong>.
          </p>
          {isNew &&
          <div className="alert alert-warning">
            Todavía no hay ajustes guardados: la web usa los valores por defecto. Revisa y guarda para activarlos.
          </div>}
        </div>
        <div className="col-12 col-lg-6">
          <SeasonCard title="HORARIO DE VERANO" season={settings.seasons.summer} isActive={activeSeason === "summer"}
                      onChange={changeSeason("summer")}/>
        </div>
        <div className="col-12 col-lg-6">
          <SeasonCard title="HORARIO DE INVIERNO" season={settings.seasons.winter} isActive={activeSeason === "winter"}
                      onChange={changeSeason("winter")}/>
        </div>
        <div className="col-12">
          <StoreInfo settings={settings} onChange={change}/>
        </div>
        <div className="col-12">
          {message &&
          <div className={`alert alert-${message.type}`}>
            {message.texts.map(text => <div key={text}>{text}</div>)}
          </div>}
          <MySubmit text={isSaving ? "GUARDANDO..." : "GUARDAR"} style={isSaving ? { pointerEvents: "none" } : {}}/>
        </div>
      </div>
    </form>
  );
};

export default Settings;
